"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneDynamicCodeCheck = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var dynamicCode_1 = require("../../model/dynamicCode");
var service_1 = require("../../../library/base/service");
var PhoneDynamicCodeCheck = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PhoneDynamicCodeCheck, _super);
    function PhoneDynamicCodeCheck() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '测试校验验证码';
        _this.code = '101075';
        _this.desc = '测试校验验证码';
        _this.requestParams = new dynamicCode_1.PhoneDynamicCodeCheckRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return PhoneDynamicCodeCheck;
}(service_1.BaseService));
exports.PhoneDynamicCodeCheck = PhoneDynamicCodeCheck;
//# sourceMappingURL=phoneDynamicCodeCheck.js.map